import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

const WithTimeout = (props) => {
  const { shouldShow, setShouldShow, timeout, children } = props;
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (shouldShow) {
        setShouldShow(false);
      }
    }, timeout);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [shouldShow, timeout]);

  return shouldShow ? <>{children}</> : null;
};

export default WithTimeout;

WithTimeout.defaultProps = {
  timeout: 3000,
};

WithTimeout.propTypes = {
  shouldShow: PropTypes.bool,
  setShouldShow: PropTypes.func,
  timeout: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};
